import React from 'react';
import '../App.css';
import {FaPlusSquare} from 'react-icons/fa';
import Filter from 'bad-words';
let filter=new Filter();

class Form extends React.Component{
  constructor(props){
    super(props);
    this.state={
      task: {
        title:'',
        user:'',
        score:0
      }
    }
  }


  createTask=(e)=>{
    e.preventDefault();
    let title=filter.clean(this.state.task.title);
    let user=filter.clean(this.state.task.user);
    //console.log(task);
    let task=Object.assign(this.state.task,{
      title, user
    });
    this.props.onClickFunction(task);
    this.setState((prevState)=>({
      task: {
        title:'',
        user:'',
        score:0
      }
    }))
  }

  handleChange=(e)=>{
   //let obj=e.target;
   //console.log(e.target.name+" "+e.target.value);
   let task=Object.assign(this.state.task,{
     [e.target.name]: e.target.value
   });
    this.setState({
      task
    });
  //  console.log(this.state.task.title+" "+this.state.task.user);
  }

  render(){
    return(
      <div className="Form">
        <form className="innerForm"onSubmit={this.createTask}>
          <input type="text"
            autoFocus
            name="title"
            className="Input"
            id="FormTitle"
            placeholder="Say something"
            value={this.state.task.title}
            onChange={this.handleChange}>
          </input>
          <input type="text"
            name="user"
            className="Input"
            placeholder="Your name"
            value={this.state.task.user}
            onChange={this.handleChange}>
          </input>
          <button className="inputButton"type="submit"onClick={this.createTask}><FaPlusSquare/></button>
        </form>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Components/Form.js